<template>
  <div class="file">
    <component v-bind:is="mimeTypeComponentName" :gFile="gFile" :gBaseUrl="gBaseUrl"></component>
    <div class="info">
      <a :href="gFile.webViewLink" target="_blank"><img :src="gFile.iconLink" class="icon">{{gFile.name}}</a>
      created on {{ gFile.createdTime | moment("dddd, MMMM Do YYYY, h:mm:ss a") }} -
      owned by
      <span v-for="(owner, index) in gFile.owners" :key="index" class="owner">
        <template v-if="index > 0">, </template>{{ owner.displayName }}
      </span>
      <a href="#" title="show raw data" @click.prevent.stop="showJson=!showJson">*</a>
    </div>
    <div class="description">
      {{ gFile.description }}
    </div>
    <div class="json">
      <!-- <span v-if="showJson" @click="showJson=false">hide raw data</span> -->
      <pre v-if="showJson">{{gFile}}</pre>
    </div>
  </div>
</template>

<script>
import GFileImage from '@/components/review/gfiletypes/GFileImage.vue'
import GFileVideo from '@/components/review/gfiletypes/GFileVideo.vue'
import GFileDoc from '@/components/review/gfiletypes/GFileDoc.vue'
import GFileAudio from '@/components/review/gfiletypes/GFileAudio.vue'
import { GApiMixin } from '@/mixins/GApiMixin.js'
import { mapState } from 'vuex'
export default {
  name: 'GFile',
  mixins: [GApiMixin],
  props: {
    gFileId: String

  },
  components: {
    GFileImage,
    GFileVideo,
    GFileDoc,
    GFileAudio
  },
  data () {
    return {
      showIframe: false,
      showJson: false
    }
  },
  computed: {
    ...mapState(['isSignedIn']),
    gBaseUrl () {
      return (this.isSignedIn) ? 'https://drive.google.com/a/redpaperheart.com' : 'https://drive.google.com'
    },
    gFile () {
      return this.gFilesMap[this.gFileId]
    },
    // gFile () {
    //   console.log('GFILE', this.gFilesMap[this.gFileId])
    //   return this.gFilesMap[this.gFileId]
    // },
    mimeTypeComponentName () {
      let componentName = ''
      switch (this.gFile.mimeType) {
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
          componentName = 'GFileImage'
          break
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/3gpp':
          componentName = 'GFileVideo'
          break
        case 'application/pdf':
        case 'application/vnd.google-apps.document':
        case 'application/vnd.google-apps.presentation':
        case 'application/vnd.google-apps.spreadsheet':
          componentName = 'GFileDoc'
          break
        // case 'audio/aiff':
        case 'audio/mpeg':
        case 'audio/wav':
        case 'audio/ogg':
          componentName = 'GFileAudio'
          break
      }
      return componentName
    }
  }
  // "webContentLink": "https://drive.google.com/a/redpaperheart.com/uc?id=18eS7CpmSik4NeXvVyjqKaA6dhmmVWTfn&export=download",
  // "webViewLink": "https://drive.google.com/a/redpaperheart.com/file/d/18eS7CpmSik4NeXvVyjqKaA6dhmmVWTfn/view?usp=drivesdk"
  // "videoMediaMetadata": {
  //       "width": 1920,
  //       "height": 1040,
  //       "durationMillis": "26000"
  //     },
}
</script>
